import { useEffect } from "react"
import { useQuery } from "urql"

import { type ProductFreight, ProductFreightsDocument, type Query } from "@/graphql/codegen/graphql"
import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

export const useFreightClass = (): {
  data: ProductFreight[] | null
  fetching: boolean
  fetch: () => void
} => {
  const [{ data, error, fetching }, fetch] = useQuery<Pick<Query, "productFreight">>({
    query: ProductFreightsDocument,
  })

  const hasError = error?.message || data?.productFreight.list.__typename === "GraphqlResourceRequestFailure"
  const notify = useNotificationsStore(({ enqueueNotification }) => enqueueNotification)

  useEffect(() => {
    if (hasError) {
      notify({
        message: "Error fetching product freights information",
        type: NotificationType.Error,
      })
    }
  }, [hasError, notify])

  return {
    data:
      data?.productFreight.list.__typename === "GetAllProductFreightsSuccess"
        ? data.productFreight.list.productFreights
        : null,
    fetching,
    fetch,
  }
}
